const defineCustomElement = (WebComponentName, CustomElement) => {
    if (window.customElements.get(WebComponentName) == null) {
        window.customElements.define(WebComponentName, CustomElement);
    }
};
export default defineCustomElement;
